import React, { Component } from "react";
import ThemeOption from "./ThemeOption";
import styled from "styled-components";

const OptionsContainer = styled.div`
    display: flex;
    position: relative;
    margin-left: -6px;
    
    label {
        font-size: 10.5px;
        width: 100%;
        left: 0;
        font-weight: 500;
        color: #555;
        margin-top: 8px;
        display: block;
        white-space: nowrap;
        text-align: center;
    }
`;

export default class ThemeOptions extends Component {
    constructor() {
        super();

        this.renderOptions = this.renderOptions.bind(this);
    }

    renderOptions(items) {
        const { theme, property, update } = this.props;

        return items.map((item, index) => {
            switch (item.value) {
                case "none_left":
                case "underline_left":
                case "bar_top_left":
                case "block_left":
                    const selected = theme[property].includes(
                        item.value.replace("_left", "")
                    );
                    return (
                        <ThemeOption
                            update={update}
                            item={item}
                            selected={selected}
                            property={property}
                            key={index}
                        />
                    );
                case "left":
                case "center":
                    let disabled = ["bar_left"].includes(theme.styleDecoration);
                    const Delimiter = theme.styleDecoration.lastIndexOf("_");
                    const value =
                        theme.styleDecoration.substring(
                            0,
                            Delimiter < 0
                                ? theme.styleDecoration.length
                                : Delimiter
                        ) +
                        "_" +
                        item.value;
                    item.value = value;
                    return (
                        <ThemeOption
                            update={update}
                            item={item}
                            selected={theme[property] === value && !disabled}
                            property={property}
                            disabled={disabled}
                            key={index}
                        />
                    );

                default:
                    return (
                        <ThemeOption
                            update={update}
                            item={item}
                            selected={theme[property] === item.value}
                            property={property}
                            key={index}
                        />
                    );
            }
        });
    }
    render() {
        const { title, options, className } = this.props;
        return (
            <div className={className}>
                <h4>{title}</h4>
                <OptionsContainer>
                    {this.renderOptions(options)}
                </OptionsContainer>
            </div>
        );
    }
}
